'use client';

import { IconList } from '@/components/ui/icons';

type Props = {
  width: string;
  height: string;
  className: string;
  unreadChannel: boolean;
};

export const ChannelListIcon = ({ width, height, className, unreadChannel }: Props) => {
  return (
    <div className='relative'>
      {unreadChannel && (
        <span className='absolute right-0 top-0 z-10 block size-2 rounded-full bg-kl-red' />
      )}
      <IconList width={width} height={height} className={className} />
    </div>
  );
};
